import { inject, Injectable } from "@angular/core";
import { AppConfig } from "../config/app.config";
import { HttpClient, HttpParams } from "@angular/common/http";
// import { BrokerResponse, companyLandingResponse } from "../models/CompanyList";
import { BranchContactPayload, BranchContactResponse, BranchDetailsResponse, BranchLandingResponse, BranchLlyodPayload, BranchLlyodResponse, BranchRequestPayload, CompanyDetailsResponse, companyLandingResponse, CompanyMap, CompanyRequestPayload, companyTypes, CountriesList, MailconfigRequestPayload, ProductApprovedListResponse,
     ProductSlDetailsRequestPayload, ProductStateApprovedListResponse, StateList, UserConfigDetails, UserConfigRequestPayload, UserDetailsRequestPayload, UserDetailsResponse, UserLandingResponse, UserRoleListResponse } from "../models/SystemAdmin.model";
import {  BrokerResponse } from "../models/QuoteList";
import { AuthService } from "../auth/auth.service";

@Injectable({
    providedIn: 'root'
})
export class SystemAdminService{

    private apiUrl = AppConfig.apiUrl;
    authservice = inject(AuthService)       
    private token = this.authservice.getToken()    
    httpClient = inject(HttpClient);
    
    private COMPANY_TYPE_KEY = 'companyTypeList';

    getAllCompanyList(){
        const path = `/api/CompanyMaster/GetAllCompanies`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<companyLandingResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getAllCompanyTypes(){
        const path = `/api/CompanyMaster/GetCompanyTypes`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<companyTypes>(`${this.apiUrl}/Proxy?path=${encodedPath}`)
    }

    getAllCompaniesList(pageNumber: number, pageSize: number, additionalParams: { [key: string]: string | number | null }){
        let params = new HttpParams()
            .set('pageNumber', pageNumber)
            .set('numOfRecord', pageSize);
    
        params = this.addParams(params, additionalParams);
    
        // Store token separately
        const token = String(this.token);
    
        // Remove token from params for encoding
        params = params.delete('token');
    
        const path = `/api/CompanyMaster/GetAllCompanyLandingGrid`;
        const encodedPath = encodeURIComponent(path);
        let url = `${this.apiUrl}/Proxy?path=${encodedPath}`;
    
        if (params.keys().length > 0) {
            url += '?' + encodeURIComponent(params.toString());
        }
    
        // url += `&token=${token}`;
    
        return this.httpClient.get<companyLandingResponse>(url);
    }
    
    getAllUsersList(pageNumber: number, pageSize: number, additionalParams: { [key: string]: string | number | null }) {
        let params = new HttpParams()
            .set('pageNumber', pageNumber)
            .set('numOfRecord', pageSize);
    
        params = this.addParams(params, additionalParams);
    
        // Store token separately
        const token = String(this.token);
    
        // Remove token from params for encoding
        params = params.delete('token');
    
        const path = `/api/UserMaster/GetAllUsersLandingGrid`;
        const encodedPath = encodeURIComponent(path);
        let url = `${this.apiUrl}/Proxy?path=${encodedPath}`;
    
        if (params.keys().length > 0) {
            url += '?' + encodeURIComponent(params.toString());
        }
    
        // url += `&token=${token}`;
    
        return this.httpClient.get<UserLandingResponse>(url);
    }
    
    getAllBranchesList(pageNumber: number, pageSize: number, additionalParams: { [key: string]: string | number | null }) {
        let params = new HttpParams()
            .set('pageNumber', pageNumber)
            .set('numOfRecord', pageSize);
    
        params = this.addParams(params, additionalParams);
    
        // Store token separately
        const token = String(this.token);
    
        // Remove token from params for encoding
        params = params.delete('token');
    
        const path = `/api/BranchMaster/GetAllBranchLandingGrid`;
        const encodedPath = encodeURIComponent(path);
        let url = `${this.apiUrl}/Proxy?path=${encodedPath}`;
    
        if (params.keys().length > 0) {
            url += '?' + encodeURIComponent(params.toString());
        }
    
        // url += `&token=${token}`;
    
        return this.httpClient.get<BranchLandingResponse>(url);
    }
    

    getCompanyDropdownList() {
        const path = `/api/CompanyMaster/GetAllCompanies`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<CompanyDetailsResponse[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getBranchDropdownList() {
        const path = `/api/BranchMaster/GetAllBranches`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<BranchDetailsResponse[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getUserRoleList() {
        const path = `/api/UserMaster/GetAllRoles`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<UserRoleListResponse[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    addNewCompany(payload: CompanyRequestPayload) {
        const path = `/api/CompanyMaster/CreateCompany`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }

    private addParams(params: HttpParams, additionalParams: { [key: string]: string | number | null }): HttpParams {
        for (const [key, value] of Object.entries(additionalParams)) {
          if (value !== null && value !== undefined) {
            params = params.set(key, value.toString());
          }
        }
        return params;
    }

    updateCompany(payload: CompanyRequestPayload, companyId: string) {
        const path = `/api/CompanyMaster/UpdateCompany/${companyId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }

    getCompanyDetails(companyId: string) {
        const path = `/api/CompanyMaster/GetCompanyByCompanyId/${companyId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<CompanyDetailsResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getBranchByCompanyId(companyId: string){
        const path = `/api/BranchMaster/GetBranchesByCompanyIdAsync/${companyId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<BranchDetailsResponse[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getBranchDetails(branchId: string) {
        const path = `/api/BranchMaster/GetBranchesByBranchId/${branchId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<BranchDetailsResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getBranchContactDetails(branchId: string) {
        const path = `/api/BranchMaster/GetBranchContacts/${branchId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<BranchContactResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getBranchLlyodDetails(branchId: string) {
        const path = `/api/BranchMaster/GetBranchLloydDetails/${branchId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<BranchLlyodResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    addBranchDetails(payload: BranchRequestPayload, companyId: string) {
        const path = `/api/BranchMaster/CreateBranch/${companyId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload); 
    }

    updateBranchDetails(payload: BranchRequestPayload, branchId: string) {
        const path = `/api/BranchMaster/UpdateBranchDetails/${branchId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload); 
    }

    updateBranchContact(payload: BranchContactPayload, branchId: string) {
        const path = `/api/BranchMaster/UpdateBranchContact/${branchId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload); 
    }

    updateBranchllyod(payload: BranchLlyodPayload | {"lloydsBrokerAssigned": number}, branchId: string) {
        const path = `/api/BranchMaster/UpdateLloydsBrokerDetails/${branchId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload); 
    }

    saveUserDetails(payload: UserDetailsRequestPayload) {
        const path = `/api/UserMaster/CreateUser`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload); 
    }

    updateEmailAddress(userId: string, isResetFlag: string){
        const path = `/api/UserMaster/SendCreatePassword?userId=${userId}&isReset=${isResetFlag}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, null); 
    }

    getUserDetails(userId: string) {
        const path = `/api/UserMaster/GetUserByUserId/${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<UserDetailsResponse>(`${this.apiUrl}/Proxy?path=${encodedPath}`); 
    }

    updateUserDetails(payload: UserDetailsRequestPayload) {
        const path = `/api/UserMaster/UpdateUserCreation`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload); 
    }

    saveProductSlDetails(payload: ProductSlDetailsRequestPayload) {
        const path = `/api/UserMaster/AddUserApprovedProductState`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload); 
    }

    getAllApprovedProductList() {
        const path = `/api/UserMaster/GetAllProducts`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<ProductApprovedListResponse[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getAllApprovedProductStatesList(userId: string) {
        const path = `/api/UserMaster/ApprovedProductStates/${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<ProductStateApprovedListResponse[]>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    // removeProductSlDetails(approvedProductId: any, isActive: number) {
    //     return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}/api/UserMaster/IsActiveUpdateProducts/${approvedProductId}`, isActive);
    // }

    removeProductSlDetails(approvedProductId: any) {
        const path = `/api/UserMaster/IsActiveUpdateProducts/${approvedProductId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`,null);
    }

    getUserConfig(userId: string){
        const path = `/api/UserMaster/GetUserConfigByUserId/${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<UserConfigDetails>(`${this.apiUrl}/Proxy?path=${encodedPath}`); 
    }

    resetUserSession(userId : number){
        const path = `/api/Home/ResetUserSession?userId=${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, null); 
        //return this.httpClient.post(`${this.apiUrl}/Home/ResetUserSession?userId=${userId}`,null); 

        
    }

    updateUserConfig(payload: UserConfigRequestPayload, userId: string){
        const path = `/api/UserMaster/UpdateUserConfig/${userId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload); 
    }

    saveMailConfig(payload: MailconfigRequestPayload) {
        const path = `/api/MailConfig/CreateMailConfig/`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload); 
    }

    getMailConfig() {
        const path = `/api/MailConfig/GetAllMailConfig`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    updateMailConfig(configId: number, payload: any) {
        const path = `/api/MailConfig/UpdateMailConfig/${configId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }
    
    saveQuoteConfig(payload: any) {
        const path = `/api/QuoteConfigs/CreateQuoteConfig/`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload); 
    }

    getQuoteConfig() {
        const path = `/api/QuoteConfigs/GetAllQuoteConfig/`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    updateQuoteConfig(configId: number,payload: any) {
        const path = `/api/QuoteConfigs/UpdateQuoteConfig/${configId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload); 
    }

   

    saveFileConfig(payload: any) {
        const path = `/api/FileSystemConfig/CreateFileConfig/`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload); 
    }

    getFileConfig() {
        const path = `/api/FileSystemConfig/GetAllFileConfig/`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    updateFileConfig(configId: number,payload: any) {
        const path = `/api/FileSystemConfig/UpdateFileConfig/${configId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload); 
    }

    saveSystemConfig(payload: any) {
        const path = `/api/SystemConfig/CreateSystemConfig/`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload); 
    }

    getSystemConfig() {
        const path = `/api/SystemConfig/GetAllSystemConfig/`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    updateSystemConfig(configId: number,payload: any) {
        const path = `/api/SystemConfig/UpdateSystemConfig/${configId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }

    getCountryList() {
        const path = `/api/Clearance/GetCountriesList`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<CountriesList>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    getStateByCountryId(countryId: number) {
        const path = `/api/Clearance/States?countryId=${countryId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<StateList>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    addProducerSlaNumber(payload: any) {
        const path = `/api/CompanyMaster/AddNewJerseyTransactionNum`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }

    UpdateNJTN(payload: any) {
        const path = `/api/CompanyMaster/UpdateNJTN`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, payload);
    }

    GetAllNJTN() {
        const path = `/api/CompanyMaster/GetAllNJTN`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<any>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    GetNJTNForCompany(companyId: number) {
        const path = `/api/CompanyMaster/GetAllNJTN?companyId=${companyId}`
        const encodedPath = encodeURIComponent(path);
        return this.httpClient.get<any>(`${this.apiUrl}/Proxy?path=${encodedPath}`);
    }

    setBranchCountryID(countryID: string) {
        sessionStorage.setItem('branchCountryID', countryID);
    }

    setSysUserEmailID(emailID: string) {
        sessionStorage.setItem('sysEmailID', emailID);
    }

    removeBranchCountryID(){
        sessionStorage.removeItem('branchCountryID');
    }

    removeSysUserEmailID(){
        sessionStorage.removeItem('sysEmailID');
    }

    setCompanyList(statusData: companyTypes[]) {
        const transformedData: CompanyMap = {};
        statusData.forEach((item) => {
            transformedData[item.code] = {
            gencodeId: item.gencodeId,
            code: item.code,
            };
        });
        sessionStorage.setItem('companyTypeList', JSON.stringify(transformedData));
        }

    setCompanyId(companyId: number) {
         sessionStorage.setItem('companyId', String(companyId));
        }

    getStatusId(){
        return sessionStorage.getItem('companyId');
      }

    getCompanyListFromStorage() {
        const storedData = sessionStorage.getItem('companyTypeList');
        if (storedData) {
          return JSON.parse(storedData);
        }
        return null;
      }


    setCompanyTypeList(companyTypes: any[]) {
        if (!companyTypes || companyTypes.length === 0) {
            return;
        }
    
        // Convert array to an object using gencodeId as the key
        const companyTypeMap = companyTypes.reduce((acc, type) => {
            acc[type.gencodeId] = type;
            return acc;
        }, {});
    
        sessionStorage.setItem(this.COMPANY_TYPE_KEY, JSON.stringify(companyTypeMap));
    }
    
    

    getCompanyTypeList(): any {
        const storedData = sessionStorage.getItem(this.COMPANY_TYPE_KEY);
        
        if (!storedData) {
            return {};
        }
    
        const parsedData = JSON.parse(storedData);
        return parsedData;  // Now returns an object, not an array
    } 
    
    
}